import {Component} from '@angular/core';

@Component({
    selector: 'app-borrower-testimonials-section',
    templateUrl: './borrower-testimonials-section.component.html',
    styleUrls: ['../../../../assets/styles/new-styles.css', './borrower-testimonials-section.component.css']
})
export class BorrowerTestimonialsSectionComponent {
}
